import formatAccountingNumber from "./formatAccountingNumber";
import formatCompactNumber from "./formatCompactNumber";
import formatInEasternArabicNumerals from "./formatInEasternArabicNumerals";
import formatNumberWithCommas from "./formatNumberWithCommas";

import formatSentenceCase from "./formatSentenceCase";
import formatTitleCase from "./formatTitleCase";
import formatTitleCasePreserveCase from "./formatTitleCasePreserveCase";

const FormatUtils = {
  formatAccountingNumber,
  formatCompactNumber,
  formatSentenceCase,
  formatInEasternArabicNumerals,
  formatNumberWithCommas,
  formatTitleCase,
  formatTitleCasePreserveCase,
};

export default FormatUtils;
